import { NavLink } from 'react-router-dom';
import { sidebarConfig } from '@backstage/core-components';
import Link from '@mui/material/Link';
import { makeStyles } from '@mui/styles';
import { XelerateSidebarLogoFull } from '@xlrt/components';
import { useTheme } from '@mui/material/styles';

const useSidebarLogoStyles = makeStyles({
  root: {
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const theme = useTheme();
  const primaryColor =
    theme.palette.mode === 'dark'
      ? '#1EEF97'
      : 'var(--xlrt-color-future-green800)';
  const textColor = theme.palette.mode === 'dark' ? 'white' : '#222222';
  return (
    <div className={classes.root}>
      <Link
        component={NavLink}
        to="/"
        underline="none"
        className={classes.link}
        aria-label="Home"
      >
        <XelerateSidebarLogoFull
          primaryColor={primaryColor}
          textColor={textColor}
        />
      </Link>
    </div>
  );
};

export default SidebarLogo;
